{
  "skip-to-main-content": "Spring til hovedindhold",
  "homepage-title": "Book klasser og kurser",
  "homepage-choose-week": "Vælg uge",
  "header-membersapp": "Booking Portal",
  "home": "Hjem",

  "activity": "Aktivitet",
  "all": "Alle",
  "sessions": "Aktivität",
  "courses": "Kurser",
  "course": "Kursus",
  "events": "Arrangementer",
  "yesterday": "I går",
  "today": "I dag",
  "tomorrow": "I morgen",
  "nav-booking": "Book",
  "nav-bookings": "Bookinger",
  "nav-tickets": "Billetter",
  "nav-account": "Konto",
  "desktop-nav-booking": "Book",
  "desktop-nav-bookings": "Bookninger",
  "desktop-nav-tickets": "Billetter",
  "desktop-nav-account": "Min konto",
  "settings-button-aria": "Åbn indstillinger",
  "book-courses-title": "Book dine svømmeskolekurser",
  "book-sessions-title": "Book dine sessioner her",
  "activity-not-bookable": "Ikke bookbar",
  "activity-locked-out": "Spærret",
  "activity-not-bookable-description": "Denne aktivitet kan ikke bookes i øjeblikket.",
  "activity-bookable-from": "Denne aktivitet kan bookes fra",
  "back-to-home": "Tilbage",
  "book-button": "Book",
  "book-activity": "Book aktivitet",
  "choose-date": "Vælg dato",
  "to-next-week": "Til næste uge",
  "to-prev-week": "Til forrige uge",
  "place": "Plads",
  "places": "pladser",
  "left": "tilbage",
  "enqueue": "Stil dig i kø",
  "booking-reference": "Bookingnummer",
  "participants-in-queue": "Antal deltagere i køen",
  "participants-booked": "booket",
  "participants-has-booked": "Deltagere har booket",
  "in-queue": "{{queue}} i kø",
  "queue": "Kø",
  "queue-position": "Køplads",
  "queue-description": "Bemærk, at dette er en køreservation og betyder ikke, at du har fået pladsen. Hvis en deltager afbestiller, kan du bekræfte din plads og betale for reservationen.",
  "full": "Udsolgt",
  "choose-occasion": "Vælg lejlighed",
  "occasions": "Lejligheder",
  "first-occasion": "Første lejlighed",
  "participants": "Deltagere",
  "participant-already-booked": "Allerede booket",
  "of": "af",
  "next-session-title": "Næste aktivitetssession",
  "next-session-link": "Naviger til næste aktivitetssession",
  "next-session-exists": "Næste session for denne aktivitet i denne uge er",
  "next-session-empty": "Dette er den sidste aktivitetssession for denne aktivitet i ugen. Naviger til næste uge og tjek der.",
  "statistics-label": "Aktivitet",
  "statistics-description": "Antal personer på anlægget",
  "choose-managed-title": "Vælg deltager",
  "choose-managed-body": "Vælg deltagere til aktiviteten. Hvis du booker et barn eller et andet familiemedlem, tryk på \"Ny bruger\" for at tilføje dem til din liste.",
  "continue": "Fortsæt",
  "confirm-title": "Bekræft booking",
  "slide-confirm": "Træk for at bekræfte",
  "slide-cancel": "Træk for at afbestille",
  "booking-completed": "Din booking er nu foretaget",
  "booking-reserved": "Din booking er reserveret",
  "booking-full-title": "Denne aktivitet er udsolgt.",
  "booking-full-queue-description-price": "Du har op til 24 timer til at foretage betalingen fra det øjeblik, din købokning i køen accepteres.",
  "booking-full-queue-description-free": "Du vil automatisk blive booket, hvis der bliver ledige pladser. Hold øje med en bekræftelsesmail, der bliver sendt til dig.",
  "toast-pay-booking": "Du har ikke betalt din booking. Betal venligst snarest for ikke at miste din plads!",
  "toast-pay-within": "Du skal betale inden for",
  "toast-pay-now": "Betal nu",
  "toast-ticket-activated": "Billetten er nu aktiveret",
  "toast-user-created": "Brugeren er nu oprettet!",
  "toast-password-changed": "Din adgangskode er nu ændret",
  "toast-user-not-found": "Kunne ikke finde brugeren. Prøv at logge ud og ind igen og prøv igen.",
  "toast-ticket-not-found": "Kunne ikke finde billetten. Tjek, om serienummeret er korrekt, og prøv igen.",
  "toast-ticket-not-activable": "Denne billet behøver ikke aktiveres",
  "toast-old-password-incorrect": "Den gamle adgangskode er forkert",
  "toast-passwords-incorrect": "Adgangskoderne stemmer ikke overens",
  "toast-error-password-reuse": "Du kan ikke genbruge et tidligere adgangskode.",
  "toast-error-password-capital": "Du skal have mindst et stort bogstav i adgangskoden",
  "toast-password-changed-successfully": "Adgangskoden er ændret med succes. Du kan nu logge ind med din nye adgangskode.",
  "toast-user-already-booked": "Brugeren er allerede booket på denne aktivitet.",
  "toast-something-error": "Noget gik galt. Prøv igen senere!",
  "toast-used-email": "E-mailen er allerede registreret. Prøv en anden.",
  "toast-invalid-ssn": "CPR-nummeret er ugyldigt. Tjek antallet af cifre og prøv igen.",
  "toast-used-ssn": "CPR-nummeret er allerede i brug. Hvis du allerede har en konto, kan du logge ind i stedet.",
  "toast-used-ssn-managed": "CPR-nummeret er allerede registreret.",
  "toast-changed-user": "Du har nu skiftet bruger",
  "toast-changed-photo": "Billedet er nu ændret",
  "toast-photo-upload-error": "Noget gik galt, prøv et andet billede",
  "toast-changed-info": "Brugeroplysningerne er nu opdateret",
  "toast-logout-success": "Du er nu logget ud",
  "toast-account-created": "Kontoen er nu oprettet!",
  "toast-error-cancellation-time": "Sidste afbestillingstidspunkt er overskredet.",
  "toast-error-user-not-found": "E-mailadressen findes ikke i systemet",
  "toast-error-user-in-queue": "Deltageren er allerede i kø til denne aktivitet.",
  "toast-error-user-max-bookings": "Deltageren har nået det maksimale antal bookinger.",
  "toast-cancelled-booking": "Din reservation er blevet annulleret.",
  "toast-reset-mail-success": "Nulstillings-e-mail er sendt til e-mailadressen",
  "toast-navigated-next-date": "Navigeret til lejligheden",
  "loading-spinner-wait": "Vent venligst...",
  "no-activities-available": "Der er i øjeblikket ingen tilgængelige klasser eller kurser",
  "no-sessions-available": "Ingen aktiviteter tilgængelige denne dato.",
  "no-courses-available": "Der er i øjeblikket ingen tilgængelige kurser",
  "no-sessions-available-landing": "Ingen bookbare sessioner",
  "no-courses-available-landing": "Ingen bookbare kurser",
  "no-allotments-available": "Der er i øjeblikket ingen tilgængelige arrangementer",
  "no-allotments-available-landing": "Ingen bookbare arrangementer",
  "no-products-available": "Der er i øjeblikket ingen tilgængelige produkter",
  "need-to-login-title": "Du skal logge ind",
  "need-to-login-description": "For at kunne booke klasser og kurser skal du logge ind.",
  "need-to-login-view-bookings": "Du skal logge ind for at se dine bookinger",
  "need-to-login-view-tickets": "Du skal logge ind for at se dine billetter",
  "to-login-page": "Til login-siden",
  "create-account": "Opret konto",
  "create-account-first-description": "Opret en konto i dit eget navn. Hvis du skal booke dit barn ind på svømmeskole, registrerer du dig selv som den ansvarlige værge. Når du har logget ind og skal booke, får du mulighed for at specificere deltagere og derefter indtaste barnets navn og CPR-nummer.",
  "create-account-second-title": "Har du problemer med at registrere dig?",
  "create-account-second-description": "Hvis dit CPR-nummer allerede er i vores kunderegister (f.eks., hvis du har købt et månedskort hos os), kan du ikke registrere dig som en ny kunde, da vi kræver et unikt CPR-nummer. Kontakt svømmehallen, og vi vil hjælpe dig.",
  "forgot-password": "Glemt adgangskode",
  "login": "Log ind",
  "logout": "Log ud",
  "duration": "Varighed",
  "close": "Luk",
  "close-dialog": "Luk dialogboksen",
  "booking-page-description": "Her kan du se alle kommende bookinger, der er foretaget. Klik på bookingerne for at få mere information om dem.",
  "booking-page-your-bookings": "Dine bookinger",
  "booking-page-cancellations": "Aflysninger",
  "no-bookings-found": "Der er endnu ikke foretaget nogen bookinger",
  "no-cancellations-found": "Der er endnu ikke foretaget nogen aflysninger",
  "show-latest-bookings": "Her er dine seneste bookinger",
  "cancel": "Afbestil",
  "cancelled": "Afbestilt",
  "activity-cancelled": "Aktiviteten blev afbestilt",
  "cancellation-failed": "Afbestillingen fejlede",
  "activity-cancel": "Afbestil aktivitet",
  "activity-cancel-description": "Du er ved at afbestille aktiviteten. Bemærk, at dette ikke kan fortrydes.",
  "activity-review-cancellation": "Bekræft afbestilling",
  "day": "dag",
  "days": "dage",
  "hour": "time",
  "hours": "timer",
  "minute": "minut",
  "minutes": "minutter",
  "statistics-people-title": "Aktivitet",
  "statistics-people-description": "Antal personer på anlægget",
  "statistics-not-visited": "Du har endnu ikke besøgt os",
  "statistics-title": "Dine besøg",
  "statistics-visited-description": "Du har besøgt os mest i disse måneder",
  "latest-notifications": "Seneste meddelelser",
  "see-all": "Se alle",
  "ticket-page-header": "Billetter",
  "ticket-page-no-tickets": "Ingen billetter fundet",
  "ticket-page-no-active-tickets": "Ingen aktive billetter fundet",
  "ticket-page-read-more": "Tryk på den billet, du vil skanne eller læse mere om",
  "ticket-page-last-used": "Senest brugt",
  "ticket-page-active": "Gyldig",
  "ticket-page-not-valid": "Ugyldig",
  "ticket-page-clips-left": "Klip tilbage",
  "ticket-page-belongs-to": "Tilhører",
  "ticket-valid": "Gyldighed",
  "ticket-invalid": "Billet ugyldig",
  "ticket-active": "Aktiv",
  "ticket-blocked": "Blokkeret",
  "ticket-cancelled": "Annulleret",
  "ticket-not-active": "Ikke aktiv",
  "ticket-not-used": "Ikke brugt endnu",
  "activate-ticket": "Aktivér billet",
  "activate-ticket-description": "Hvis din billet skal aktiveres, kan du gøre det her. Hvis du har købt billetten i en kasse eller i webshoppen, aktiveres billetten normalt ved købet.",
  "activate-ticket-number-label": "Serienummer",
  "activate-ticket-number-description": "Kan se ud som f.eks. F3A8014A099133",
  "complete-registration-header": "Fuldfør registrering",
  "complete-registration-first-description": "For at oprette din konto, har du også brug for et kodeord. Du har modtaget en e-mail med et link, hvor du kan vælge kodeordet.",
  "complete-registration-second-description": "Når du har indstillet et kodeord, kan du nemt logge ind og begynde at booke!",
  "complete-registration-shortcuts": "Genveje til e-mailsiderne",
  "customer-info-header": "Kundeoplysninger",
  "customer-info-title": "Rediger kundeoplysninger",
  "customer-info-description": "Her kan du ændre dine oplysninger",
  "save-customer-info": "Klik på 'Gem data', når du er færdig.",
  "save-customer-info-multi": "Start med at vælge en bruger, og klik på 'Gem detaljer', når du er færdig.",
  "customer-info-select-user": "Vælg bruger",
  "customer-info-base-info": "Grundoplysninger",
  "customer-info-firstname": "Fornavn",
  "customer-info-lastname": "Efternavn",
  "customer-info-email": "E-mailadresse",
  "customer-info-civic": "CPR-nummer",
  "customer-info-phone-home": "Telefonnummer (hjemme)",
  "customer-info-phone-mobile": "Telefonnummer",
  "customer-info-phone-work": "Telefonnummer (arbejde)",
  "customer-info-company": "Virksomhed",
  "customer-info-phone-error": "Telefonnummeret må kun indeholde tal og plus-tegn",
  "customer-info-address": "Adresseoplysninger",
  "customer-info-address-Generic": "Adresse",
  "customer-info-address-Delivery": "Leveringsadresse",
  "customer-info-address-Invoice": "Fakturaadresse",
  "customer-info-street": "Gade",
  "customer-info-street-number": "Nummer",
  "customer-info-city": "By",
  "customer-info-postal-code": "Postnummer",
  "customer-info-postal-code-error": "Må kun indeholde tal og skal være mindst fem tal",
  "customer-info-country": "Land",
  "customer-info-save": "Gem data",
  "required-fields-marked-with": "Obligatoriske felter markeret med",
  "customer-register": "Registrer",
  "customer-add-user": "Tilføj bruger",
  "purchase-history-title": "Købshistorik",
  "account-logged-out-header": "Du er logget ud",
  "account-logged-out-description": "Log ind for at fortsætte. Du skal have en konto for at bruge bookingsystemet.",
  "account-bookings-title": "Bookinger",
  "account-bookings-description": "Se dine bookinger her",
  "account-tickets-title": "Billetter",
  "account-tickets-description": "Se dine billetter her",
  "account-purchase-history-title": "Købshistorik",
  "account-purchase-history-description": "Se dine seneste køb",
  "account-subscription-title": "Abonnement",
  "account-subscription-description": "Se dit abonnement",
  "account-subscription-change-card-success": "Betalkortet er ændret",
  "account-subscription-change-card-error": "Det lykkedes ikke at ændre betalkortet, prøv igen",
  "account-activate-ticket-title": "Aktivér billet",
  "account-activate-ticket-description": "Aktivér din billet her",
  "account-register-managed-title": "Tilføj bruger",
  "account-register-managed-description": "Tilføj bruger her",
  "account-photo-title": "Skift billede",
  "account-photo-description": "Ændr dit billede her",
  "account-password-title": "Skift adgangskode",
  "account-password-description": "Ændr din adgangskode",
  "table-saledate": "Dato",
  "table-receipt": "Kvittering",
  "table-pos": "Kasse",
  "table-total-excl-vat": "Samlet beløb ekskl. moms",
  "table-total-incl-vat": "Samlet beløb",
  "table-price-excl-vat": "Pris ekskl. moms",
  "table-price-incl-vat": "Pris",
  "table-actions": "Handlinger",
  "table-placeholder": "Filtrer kvitteringsnummer",
  "table-columns": "Kolonner",
  "table-not-found": "Ingen køb fundet",
  "table-previous": "Forrige",
  "table-next": "Næste",
  "table-page": "Side {{pageCount}} af {{maxPageCount}}",
  "table-copy-receipt": "Kopier kvitteringsnummer",
  "table-show-receipt": "Vis kvittering",
  "table-receipt-description": "Her kan du se detaljerne ved dit køb.",
  "table-article": "Produkt",
  "open-menu": "Åbn menu",
  "search-courses": "Søg kurser",
  "search-sessions": "Søg sessioner",
  "show-inactive": "Vis inaktive",
  "show-full": "Vis alle voll bookede",
  "show-full-aria-on": "Skjul alle voll bookede",
  "show-full-aria-off": "Vis alle voll bookede",
  "show-inactive-aria-on": "Skjul inaktive",
  "show-inactive-aria-off": "Vis inaktive",
  "show-cancelled": "Vis annullerede",
  "subscription-header": "Mine abonnementer",
  "subscription-description": "Nedenfor kan du se oplysninger om dine igangværende og afsluttede abonnementer. Klik på et abonnement for mere information og handlinger.",
  "subscription-status": "Status",
  "subscription-status-aborted": "Annulleret",
  "subscription-status-chargeandfailed": "Fejl ved trækning",
  "subscription-status-chargefailed": "Fejl ved trækning",
  "subscription-status-registered-label": "Registreret",
  "subscription-status-registered-successful": "Registrering fuldført",
  "subscription-status-registered": "Handling påkrævet",
  "subscription-status-cancelled": "Annulleret",
  "subscription-status-finalized": "Betalt fuldt ud",
  "subscription-status-active": "Aktiv",
  "subscription-status-pay": "Betaling påkrævet",
  "subscription-status-frozen": "Frosset",
  "subscription-state-aborted-cancelled": "Abonnementet er blevet annulleret. Du skal bestille et nyt abonnement for at fortsætte med at bruge vores service.",
  "subscription-state-registered": "Dette abonnement er ikke aktivt. Klik på nedenstående link for at fuldføre den første betaling og aktivere abonnementet.",
  "subscription-state-registeredfinalized": "Dette abonnement er aktivt, og den første betaling er blevet foretaget.",
  "subscription-state-charged": "Betaling er blevet behandlet med succes, og abonnementet er aktivt.",
  "subscription-state-chargedfailed": "Betalingen mislykkedes, sandsynligvis på grund af utilstrækkelige midler på betalingskortet eller et ugyldigt kort. Abonnementet er ikke aktivt.",
  "subscription-state-chargedandfailed": "Betalingen mislykkedes. Kontakt venligst kundeservice for assistance.",
  "subscription-state-cancelled": "Abonnementet er blevet annulleret. Du kan stadig bruge abonnementet i den periode, du har betalt for.",

  "subscription-state-active": "Her kan du se oplysninger om dit abonnement og skifte betalingskort.",
  "subscription-start-date": "Startdato",
  "subscription-end-date": "Afslutningsdato",
  "subscription-type": "Abonnementstype",
  "subscription-payments-done": "Betalte trækninger",
  "subscription-payments": "Trækninger",
  "subscription-last-payment": "Seneste trækning",
  "subscription-next-payment": "Næste trækning",
  "subscription-reference": "Reference",
  "subscription-type-fixed": "Fast",
  "subscription-type-ongoing": "Løbende",
  "subscription-pay": "Betal",
  "subscription-cancel": "Annuller abonnement",
  "subscription-cancel-confirmation": "Bekræft venligst nedenfor for at annullere abonnementet. Dette kan ikke fortrydes!",
  "subscription-change-payment": "Skift betalingskort",
  "subscription-cancel-success": "Dit abonnement er nu annulleret",
  "subscription-handle-payment": "Administrer betaling",
  "subscription-handle-payment-description": "Her kan du se betalingsmetoder og skifte betalingskort",
  "subscription-handle-payment-active": "Aktivt betalingskort",
  "subscription-handle-payment-change": "Skift betalingskort",
  "subscription-card-number": "Kortnummer",
  "subscription-card-valid-thru": "Gyldig til, måned/år",
  "subscription-history-charged": "Betalt",
  "subscription-history-failed": "Fejlet træk",
  "subscription-history-due": "Forestående",
  "subscription-history-cancelled": "Annulleret",
  "subscription-price-per-month": "Pris pr. måned",
  "subscription-table-title": "Betalingshistorik",
  "subscription-table-payment": "Betaling",
  "subscription-table-sum": "Beløb",
  "subscription-table-status": "Status",
  "subscription-table-paid": "Betalt",
  "confirm": "Bekræft",
  "add-new-user": "Ny bruger",
  "managed-header": "Tilføj bruger",
  "managed-description": "Her kan du tilføje flere personer, du vil kunne boke for, f.eks. familiemedlemmer.",
  "managed-description-extra": "Hvis personen allerede er i vores system (gennem et tidligere køb eller en booking), kan du ikke tilføje personen her. Kontakt venligst personalet på din lokale facilitet, så hjælper vi dig med registreringen.",
  "managed-add-new": "Tilføj ny bruger",
  "managed-users": "Brugere",
  "managed-click-user-to-edit": "Klik på en bruger for at redigere oplysninger.",
  "managed-edit-user-for": "Rediger oplysninger for {{name}}",
  "managed-add-new-user-header": "Tilføj bruger",
  "managed-add-new-user-description": "Når du har registreret f.eks. dit barn, kan du booke kurser og træninger for dem.",
  "photo-header": "Billede",
  "photo-description": "Vær opmærksom på, at personalet på anlægget skal kunne genkende dig på billedet.",
  "photo-alt": "Billede af",
  "photo-change": "Skift billede",
  "photo-upload-header": "Upload nyt billede",
  "photo-upload-description": "Her kan du tage et nyt billede eller uploade et billede fra din enhed.",
  "photo-change-image": "Vælg nyt billede",
  "password-header": "Skift adgangskode",
  "password-header-reset": "Nulstil adgangskode",
  "password-header-reset-title": "Nulstil",
  "password-new-description": "Vælg en ny adgangskode til din konto. Din adgangskode bliver ekstra sikker, hvis den indeholder både bogstaver og tal.",
  "password-description": "Her kan du ændre din adgangskode. Indtast først din nuværende adgangskode og derefter din nye adgangskode.",
  "password-reset-description": "Indtast din e-mailadresse og klik på send for at modtage en e-mail med et link til at nulstille din adgangskode. Husk at tjekke din spam-mappe, hvis du ikke modtager en e-mail.",
  "password-old": "Nuværende adgangskode",
  "password-new": "Ny adgangskode",
  "password-confirm-new": "Bekræft ny adgangskode",
  "password-confirm-change": "Skift adgangskode",
  "search-close": "Luk",
  "search-title": "Søg...",
  "search-placeholder": "Kurser og ugens aktiviteter, navn, beskrivelse, ID...",
  "search-no-results": "Ingen resultater fundet",
  "badge-not-paid": "Ikke betalt",
  "badge-queue": "I kø",
  "badge-cancelled": "Annulleret",
  "badge-paid": "Betalt",
  "dark-theme": "Mørkt tema",
  "language-change": "Skift sprog",
  "language-change-to": "Skift sprog til",
  "language-swedish": "svensk",
  "language-english": "engelsk",
  "language-danish": "dansk",
  "language-german": "tysk",
  "language-spanish": "spansk",
  "payment": "Betaling",
  "install-app-maybe-later": "Måske senere",
  "install-app-dont-show-again": "Vis ikke igen",
  "install-app-install": "Installer",
  "install-app-our": "Installer vores app",
  "install-app-description": "For den bedste oplevelse anbefales det at installere appen. Tryk på knappen for at installere.",
  "install-app-description-ios": "Installer vores app ved at trykke på",
  "install-app-description-ios-update": "Opdater vores app ved at trykke på",
  "install-app-description-update": "Tak for at du opdaterer appen! Tryk på knappen og kom i gang med at booke igen. Den gamle app på hjemmeskærmen kan derefter fjernes.",
  "install-app-confirmation-title": "Er du sikker?",
  "install-app-confirmation-description": "Du vil ikke modtage en påmindelse om at installere vores app igen. Hvis du fortryder, kan du trykke på",
  "install-app-confirmation-continue": "og derefter \"Installer appen\".",
  "install-app-confirmation-continue-firefox": "og derefter \"Installer\".",
  "install-app-confirmation-samsung-continue-1": "og derefter",
  "install-app-confirmation-samsung-continue-2": "\"Tilføj til startskærm\" og tryk derefter på \"Startskærm\".",
  "install-app-confirmation-safari-continue-1": "og rul derefter og tryk på:",
  "install-app-confirmation-safari-continue-2": "Tilføj til startskærm",
  "install-app-samsung-warning-title": "For dig med Samsung Browser",
  "install-app-samsung-warning-description": "Android behandler alle web-apps, der er installeret med Samsung Browser, som usikre. Vælg at installere alligevel eller skift browser for at installere.",
  "form-error-firstname": "Fornavn er obligatoriskt",
  "form-error-firstname-long": "Fornavnet må ikke overstige 100 tegn.",
  "form-error-lastname": "Efternavn er obligatoriskt",
  "form-error-lastname-long": "Efternavnet må ikke overstige 100 tegn.",
  "form-error-mail": "Email er obligatoriskt",
  "form-error-mail-invalid": "Ugyldig email-adresse",
  "form-error-civic-short": "CPR-nummer skal indeholde mindst 10 cifre",
  "form-error-civic-invalid": "Ugyldigt CPR-nummer",
  "form-error-zip": "Postnummer er obligatoriskt",
  "form-error-zip-invalid": "Ugyldigt postnummer",
  "form-error-password-short": "Adgangskode skal være mindst 5 tegn",
  "form-error-password-long": "Adgangskoden må ikke overstige 100 tegn",
  "form-error-phone": "Telefonnummer er obligatoriskt",
  "form-error-phone-invalid": "Telefonnummer skal være mellem 10-15 numre",
  "form-error-email-invalid": "Ugyldig e-mailadresse",
  "form-error-email-long": "E-mailadresse må ikke overstige 255 tegn",
  "form-error-phone-long": "Telefonnummer må ikke overstige 20 tegn",
  "form-error-street-long": "Gadeadresse må ikke overstige 255 tegn",
  "form-error-street-number-long": "Gadenummer må ikke overstige 10 tegn",
  "form-error-city-long": "By må ikke overstige 100 tegn",
  "form-error-country-long": "Land må ikke overstige 100 tegn",
  "form-error-photo-required": "Foto er påkrævet",
  "form-error-field-required": "{{field}} er påkrævet",
  "form-error-field-invalid": "Ugyldig {{field}}",
  "form-show-old-password": "Vis dit gamle adgangskode på skærmen",
  "form-hide-old-password": "Skjul dit gamle adgangskode på skærmen",
  "form-show-password": "Vis dit nye adgangskode på skærmen",
  "form-hide-password": "Skjul dit nye adgangskode på skærmen",
  "form-show-verification-password": "Vis dit nye bekræftelsesadgangskode på skærmen",
  "form-hide-verification-password": "Skjul dit nye bekræftelsesadgangskode på skærmen",
  "form-phone-short": "Telefonnummeret er for kort",
  "form-phone-long": "Telefonnummeret er for langt",
  "form-phone-invalid": "Brug kun tal til telefonnummeret",
  "cookies-title": "Cookies",
  "cookies-description": "Vi bruger nødvendige cookies på webstedet for at sikre, at det fungerer korrekt og giver dig den bedste oplevelse.",
  "cookies-link": "Læs mere om vores cookies",
  "cookies-consent-ok": "OK",
  "cookies-consent-decline": "Afvis",
  "not-found-title": "Forvundet link",
  "not-found-description": "Det ser ud til, at det link, du forsøger at nå, er forsvundet. Klik på knappen for at vende tilbage til startsiden.",
  "not-found-button": "Til startsiden",
  "not-found-eyebrow": "Fejl · Siden blev ikke fundet",
  "not-found-heading": "Denne side er forsvundet",
  "not-found-body": "Den er måske blevet flyttet, omdøbt eller har aldrig eksisteret. Under alle omstændigheder holder vi øje med den.",
  "not-found-back-home": "Til startsiden",
  "not-found-go-back": "Gå tilbage",
  "not-found-heading-course": "Vi kunne ikke finde dette kursus",
  "not-found-body-course": "Kurset er måske fjernet, eller linket er forkert. Prøv at kigge på vores kurser i stedet.",
  "not-found-heading-session": "Vi kunne ikke finde denne aktivitet",
  "not-found-body-session": "Aktiviteten er måske fjernet, eller linket er forkert. Prøv at kigge på vores aktiviteter i stedet.",
  "not-found-heading-allotment": "Vi kunne ikke finde dette arrangement",
  "not-found-body-allotment": "Arrangementet er måske fjernet, eller linket er forkert. Prøv at kigge på vores arrangementer i stedet.",
  "not-found-heading-product": "Vi kunne ikke finde denne billet",
  "not-found-body-product": "Billetten er måske fjernet eller udsolgt, eller linket er forkert. Prøv at kigge på vores billetter i stedet.",
  "not-found-heading-articlegroup": "Vi kunne ikke finde denne kategori",
  "not-found-body-articlegroup": "Kategorien er måske fjernet eller omdøbt, eller linket er forkert.",
  "accessibility-title": "Tilgængelighed",
  "offline-title": "Offline",
  "filter-title": "Filtrér",
  "sorting-facility-title": "Facilitet",
  "sorting-tag-title": "Mærkning",
  "sorting-showing-facilities": "{{count}} faciliteter valgt",
  "sorting-showing-tags": "{{count}} mærker valgt",
  "update": "Opdatering",
  "update-title": "Opdater vores app",
  "update-description": "Vores app er blevet opdateret, og du skal muligvis geninstallere den. Tryk på knappen nedenfor for at kopiere linket. Åbn derefter linket i din almindelige webbrowser og installer appen.",
  "update-copy": "Kopier installationslinket",
  "update-copied": "Kopierede linket",
  "update-finished": "Når installationen er færdig, kan du fortsætte her i browseren eller åbne appen.",
  "course-detail-title": "{{courseName}} kursinformation",
  "course-detail-description": "Her kan du se information om kurset {{courseName}}, datoer og tider, samt booke dig ind.",
  "session-detail-title": "{{sessionName}} sessionsinformation",
  "session-detail-description": "Her kan du se information om sessionen {{sessionName}}, dato og tid, samt booke dig ind.",
  "allotment-detail-title": "{{allotmentName}} aktivitetsinformation",
  "allotment-detail-description": "Her kan du se information om aktiviteten {{allotmentName}}, dato og tid, samt booke dig ind.",
  "allotments": "Arrangementer",
  "products": "Billetter",
  "ticket": "Billet",
  "product": "Produkt",
  "overview": "Overblik",
  "description": "Beskrivelse",
  "session-information": "Aktivitetsinformation",
  "course-information": "Kursinformation",
  "bookable-from": "Kan bookes fra",
  "number-of-occasions": "Antal lejligheder",
  "number-of-places": "Antal pladser",
  "number-of-booked": "Antal bookede",
  "course-id": "Kursus ID",
  "instructor": "Instruktør",
  "contact": "Kontakt",
  "length": "Længde",
  "choose-participant": "Vælg deltager",
  "create-new": "Opret ny",
  "participant": "Deltager",
  "price-group": "Prisgruppe",
  "base": "Base",
  "price-includes": "Prisen inkluderer moms og gebyrer.",
  "book": "Book",
  "book-course": "Book kursus",
  "book-session": "Book session",
  "book-allotment": "Book aktivitet",
  "login-to-book": "Log ind for at booke",
  "persons": "personer",
  "time": "Tid",
  "add-to-cart": "Læg i kurv",
  "cart": "Kurv",
  "cart-empty": "Din kurv er tom",
  "cart-total": "Total",
  "cart-checkout": "Gå til betaling",
  "cart-continue-shopping": "Fortsæt med at handle",
  "cart-open": "Åbn kurv",
  "cart-close": "Luk kurv",
  "cart-decrease-quantity": "Formindsk antal med 1",
  "cart-increase-quantity": "Forøg antal med 1",
  "cart-remove-item": "Fjern",
  "categories": "Kategorier",
  "article-groups": "Andet",
  "our-activities": "Vores aktiviteter",
  "our-activities-description": "Her er vores kommende aktiviteter, du kan også vælge at se alle aktiviteter.",
  "quantity": "Antal",
  "product-detail-title": "{{productName}} produktinformation",
  "product-detail-description": "Her kan du se information om produktet {{productName}}",
  "no-description-available": "Ingen beskrivelse tilgængelig",
  "multi-ticket": "Familiebillet",
  "form-personal-info": "Personlige oplysninger",
  "form-personal-info-description": "Udfyld venligst oplysningerne nedenfor for at fortsætte",
  "form-firstname": "Fornavn",
  "form-lastname": "Efternavn",
  "form-email": "E-mailadresse",
  "form-civic": "CPR-nummer",
  "form-civic-placeholder": "ÅÅÅÅMMDD-NNNN",
  "form-phone": "Telefonnummer",
  "form-address": "Adresse",
  "form-street": "Gade",
  "form-street-number": "Gadenummer",
  "form-zip-code": "Postnummer",
  "form-city": "By",
  "form-country": "Land",
  "form-photo": "Foto",
  "form-photo-exceed-size": "Foto overskrider maksimal størrelse",
  "form-photo-exceed-max-files": "Du kan kun uploade et maksimum af {{maxFiles}} filer.",
  "form-invalid-file-type": "Filtypen {{fileType}} er ikke acceptet.",
  "upload-file": "Upload fil",
  "uploaded-image": "Uploadet billede",
  "drop-image-or-browse": "Slip dit billede her eller klik for at gennemse",
  "max-size": "Max størrelse: {{size}} MB",
  "remove-image": "Fjern billede",
  "crop": "Beskær",
  "crop-close": "Kassér",
  "crop-error": "Der gik noget galt ved beskæring!",
  "profile-image": "Profilbillede",
  "image-cropper-alt": "Billedbeskærer",
  "loading": "Indlæser...",
  "settings": "Indstillinger",
  "settings-description": "Skift dit sprog, valuta og tema",
  "language": "Sprog",
  "currency": "Valuta",
  "theme": "Tema",
  "change-language": "Skift sprog",
  "change-language-to": "Skift sprog til",
  "choose-theme": "Vælg et tema",
  "theme-light": "Lyst",
  "theme-dark": "Mørkt",
  "theme-system": "System",
  "close-settings": "Luk indstillinger",
  "current-language": "Nuværende sprog",
  "flag": "flag",
  "out-of-stock": "Udsolgt",
  "product-type": "Produkttype",
  "regular-products": "Almindelige produkter",
  "gift-certificate": "Gavekort",
  "gift-certificates": "Gavekort",
  "multi-tickets": "Multi-billetter",
  "packages": "Pakker",
  "personal-tickets": "Personlige billetter",
  "personal-ticket-fill-out-fields": "Udfyld oplysningerne for den person, der skal bruge billetten",
  "category": "Kategori",
  "sizes": "Størrelser",
  "no-products-found": "Ingen produkter matcher de valgte filtre.",
  "results": "resultater",
  "filters": "Filtre",
  "search-products": "Søg produkter...",
  "clear-search": "Ryd søgefelt",
  "sort-by": "Sorter efter",
  "name-ascending": "Navn A-Å",
  "name-descending": "Navn Å-A",
  "price-ascending": "Laveste pris",
  "price-descending": "Højeste pris",
  "search-label": "Søg",
  "search-allotments": "Søg aktiviteter...",
  "location": "Vælg facilitet",
  "all-locations": "Steder",
  "date-range": "Fra- og til dato",
  "no-allotments-found": "Ingen aktiviteter fundet",
  "time-ascending": "Tid (stigende)",
  "time-descending": "Tid (faldende)",
  "date-not-available": "Dato ikke tilgængelig",
  "go-to-prev-month": "Gå til forrige måned {{monthName}}",
  "go-to-next-month": "Gå til næste måned {{monthName}}",
  "go-to-prev-week": "Gå til forrige uge {{previousWeek}}",
  "go-to-next-week": "Gå til næste uge {{nextWeek}}",
  "select-date": "Vælg dato",
  "select-tickets": "Vælg billetter",
  "exceeds-capacity": "Overstiger kapacitet",
  "spots-remaining": "pladser tilbage",
  "pick-date": "Vælg dato",
  "allotment-information": "Aktivitetsinformation",
  "allotment-id": "Aktivitets-ID",
  "available-courses": "Tilgængelige kurser",
  "available-sessions": "Tilgængelige sessioner",
  "available-occasions": "Tilgængelige lejligheder",
  "places-remaining": "Pladser tilbage",
  "date": "Dato",
  "change-card-view-to": "Skift til {{cardViewType}}",
  "grid-view": "gittervisning",
  "list-view": "listevisning",
  "abort": "Annuller",
  "invalid-additional-field": "Ugyldigt format for {{fieldName}}",
  "select-tickets-per-category": "Vælg antal billetter per kategori",
  "free-of-charge": "Gratis",
  "places-left": "{{count}} pladser tilbage",
  "enter-additional-information": "Indtast yderligere oplysninger",
  "enter-field": "Indtast {{field}}",
  "could-not-find-activity": "Kunne ikke finde aktiviteten",
  "could-not-find-product": "Kunne ikke finde produktet",
  "move-occasions-title": "Ombook billetter",
  "move-occasions-back-to-bookings": "Tilbage til mine bookinger",
  "move-occasions-step-of": "Trin {{current}} af {{total}} — {{label}}",
  "move-occasions-step-intro": "Introduktion",
  "move-occasions-step-booking": "Vælg booking",
  "move-occasions-step-datetime": "Dato & tid",
  "move-occasions-step-confirm": "Bekræft",
  "move-occasions-step-code": "Kode",
  "move-occasions-step-done": "Færdig",
  "move-occasions-choose-title": "Vælg booking der skal ombookes",
  "move-occasions-choose-subtitle": "Vi fandt følgende bookinger på din konto.",
  "move-occasions-datetime-title": "Vælg ny dato og tid",
  "move-occasions-choose-time": "Vælg tid",
  "move-occasions-time-helper": "Gennemstregede tider er fuldt bookede.",
  "move-occasions-confirm-title": "Bekræft din ombookning",
  "move-occasions-confirm-helper": "Kontroller oplysningerne, før du bekræfter.",
  "move-occasions-label-activity": "Aktivitet",
  "move-occasions-label-current": "Ordinær booking",
  "move-occasions-label-new": "Ombookes til",
  "move-occasions-label-quantity": "Antal billetter",
  "move-occasions-otp-title": "Bekræft med PIN-kode",
  "move-occasions-otp-subtitle": "Indtast din firecifrede kode for at bekræfte ombookningen. PIN-koden findes i bookingbekræftelsesmailen.",
  "move-occasions-otp-label": "Firecifret bekræftelseskode",
  "move-occasions-success-title": "Din ombookning er klar",
  "move-occasions-success-summary": "{{title}} er nu ombooket til {{dateTime}}, {{qty}} {{unit}}.",
  "move-occasions-next": "Næste",
  "move-occasions-back": "Tilbage",
  "move-occasions-continue": "Fortsæt",
  "move-occasions-submit": "Bekræft ombookning",
  "move-occasions-to-bookings": "Tilbage til bookingssiden",
  "move-occasions-ticket": "billet",
  "move-occasions-tickets": "billetter",
  "move-occasions-loading": "Indlæser…",
  "move-occasions-no-bookings": "Ingen ombookbare bookinger fundet.",
  "move-occasions-error-missing-token": "Kunne ikke finde bookingen. Kopiér hele linket fra bekræftelsesmailen og prøv igen.",
  "move-occasions-error-bad-token": "Kunne ikke finde billetterne. Prøv at kopiere hele linket fra bekræftelsesmailen og prøv igen.",
  "move-occasions-error-illegal-pin": "Forkert PIN-kode, indtast den korrekte kode og prøv igen",
  "move-occasions-error-no-occasions": "Der er intet tidspunkt at flytte fra",
  "move-occasions-error-too-close": "Du har valgt et tidspunkt for tæt på det oprindelige. Vælg et senere og prøv igen.",
  "move-occasions-error-invalid-parameter": "Noget gik galt. Genindlæs siden og prøv igen.",
  "move-occasions-error-api": "Noget gik galt. Genindlæs siden og prøv igen.",
  "cookies-policy-title": "Politik for cookies",
  "cookies-what-are-cookies": "Hvad er cookies?",
  "cookies-what-are-cookies-description": "Cookies er små tekstfiler, der gemmes i din browser, når du besøger webstedet. Vi bruger cookies, så webstedet fungerer optimalt, for eksempel for at holde dig logget ind på din brugerkonto, lægge varer i din indkøbskurv eller skifte sprog.",
  "cookies-our-cookies": "Hvilke typer cookies bruger vi?",
  "cookies-our-cookies-description": "Der findes forskellige typer cookies, men vores webshop bruger kun nødvendige cookies. Disse cookies kræver ikke dit samtykke, men er nødvendige for at kunne bruge webshoppen.",
  "cookies-names": "Navn",
  "cookies-purpose": "Formål",
  "cookies-storage-time": "Lageringsvarighed",
  "cookies-save-your-culture": "Gemmer dit valg af sprog og regional indstilling (f.eks. sv-SE).",
  "cookies-session-or-until-you-change-language": "Session eller indtil du ændrer sprog",
  "cookies-language-setting-used-by-translation-system": "Sprogindstilling, som bruges af oversættelsessystemet, synkroniseres med",
  "cookies-language-setting-used-by-translation-system-description": "Sprogindstilling, som bruges af oversættelsessystemet, synkroniseres med",
  "cookies-save-currency": "Gemmer valuta, som priser vises i.",
  "cookies-save-currency-description": "Session eller indtil du ændrer valuta",
  "cookies-save-saleid": "Linker din browser til den pågældende kurv/booking, så produkter og billetter forbliver mellem sider.",
  "cookies-save-saleid-description": "Session (slettes, når købet er fuldført eller kurven tømmes)",
  "cookies-save-membersapp-consent": "Husker, at du har accepteret informationen om cookies i banneren længst nede på siden.",
  "cookies-one-year": "1 år",
  "cookies-save-membersapp-theme": "Gemmer dit valg af lys, mørkt eller systemets tema.",
  "cookies-manage-cookies-in-your-browser": "Sådan håndterer du cookies",
  "cookies-manage-cookies-in-your-browser-description": "Hvis du ikke vil have, at cookies gemmes på din computer, kan du slå funktionen fra under Indstillinger i din browser. Det kan dog betyde, at visse funktioner på dette websted ikke virker som de skal. ",
  "cookies-security": "Sikkerhed",
  "cookies-security-description": "Følsom information, såsom kreditkortnumre ved betaling, overføres altid kryptert (SSL/TLS). Informationen gemmes ikke af denne website, men håndteres af betalingsudbyderen."
}
